import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { GoogleTranslateDropdown } from './GoogleTranslateDropdown';
export const GoogleTranslateMenuItem = (props)=>/*#__PURE__*/ _jsx(GoogleTranslateDropdown, {
        ...props,
        wrapper: (dropdown)=>/*#__PURE__*/ _jsx("li", {
                className: props.className || 'utilities__menu-item',
                children: dropdown
            })
    });
